<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em">I grew up in Inverell, a small rural town in north-east NSW. I started writing <em>The Falling</em> when I was 17. It took me 3 years to finally complete it. I dropped out of school at the start of grade 11, when I was 16. My first job was at a local jewellers’ that unfortunately closed early 2021. But I’m happy to say it was the best 5 years of my life working there, there was never a dull day with those lovely ladies. I am an animal fanatic, having many of mine, but we all have our favourites and mine are my two amazing cats: Pepsi and Minky. I’m a big fan of movies and my all-time favourite character is Batman.</p><br/>
<p style="text-indent:0em">I love to write, mainly because it gives me a sense of freedom. I can shut off from the world around me and go anywhere I want. My biggest inspiration is Alexandra Adornetto. Her writing makes me feel like I’m there and her books make me feel so happy and I only want my book to bring the same joy to anyone who reads it. I’m not in it for the fame and fortune. I simply want to brighten up someone’s day, like Alexandra Adornetto did for me.</p><br/>
<p style="text-indent:0em; text-align:right">—Kita Cook</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1931ee08